import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Sorting2",
  "use": "icon-Sorting2-usage",
  "viewBox": "0 0 1843 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1843 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Sorting2\"><path d=\"M921.6 0L0 1024h1843.2z\" p-id=\"10457\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol